import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { documentStatusGetter } from '../../../../components/Table/DashboardDataGridTable/value-getters/document-status.getter';
import SearchField from '../../../../components/SearchBar';

type InputProps = {
  searchValue?: string;
  onSearchChange: (newValue: string) => void;
  onManage: (id: string) => void;
  employeeIdLabel?: string;
};

export const driversColumns = ({
  onManage,
  searchValue,
  onSearchChange,
  employeeIdLabel = 'Employee ID',
}: InputProps): GridColDef[] => [
  {
    field: 'userInfo.fullName',
    headerName: 'Driver Name',
    minWidth: 180,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <b
          style={{ cursor: 'pointer' }}
          onClick={() => {
            onManage(params.row.candidateUserId);
          }}
        >
          {params.row.userInfo?.fullName || '-'}
        </b>
      );
    },
  },
  { field: 'employeeId', headerName: employeeIdLabel, minWidth: 120 },
  {
    field: 'managers.fullName',
    headerName: 'Compliance Manager',
    minWidth: 180,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <>
          {params.row?.managers
            ?.map((manager: { fullName: string }) => manager?.fullName)
            .join(', ') || '-'}
        </>
      );
    },
  },
  {
    field: 'documentRequestStatus',
    headerName: 'Status',
    minWidth: 200,
    valueGetter: documentStatusGetter,
  },
  {
    field: 'actions',
    headerName: '',
    minWidth: 200,
    align: 'right',
    headerAlign: 'right',
    renderCell: (params: GridRenderCellParams) => {
      return (
        <ButtonWithArrowIcon
          outlined={true}
          size="small"
          onClick={() => {
            onManage(params.row.candidateUserId);
          }}
        >
          Manage
        </ButtonWithArrowIcon>
      );
    },
    disableColumnMenu: true,
    sortable: false,
    renderHeader: () => (
      <SearchField
        placeholder={'Driver Search'}
        value={searchValue ?? ''}
        onChangeSearch={onSearchChange}
      />
    ),
  },
];
